import SociogramImage from '@BUP/assets/Images/Data/sociogram_image.svg'
import { useGetCurrentSociogram } from '@BUP/hooks/Sociogram/useGetCurrentSociogram'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import BupSpinner from '@BUP/components/Loading/Spinner'
import LinkInstrumentCard from '@BUP/components/Generics/Cards/InstrumentCard/link-instrument-card'
import AlertInstrumentCard from '@BUP/components/Generics/Cards/InstrumentCard/alert-instrument-card'
import InfoInstrumentCard from '@BUP/components/Generics/Cards/InstrumentCard/info-instrument-card'

const SociogramCardContent = (organizationId) => {
  const navigate = useNavigate()
  const i18n = useTranslation()

  const { isLoadingCurrentSociogram, dataCurrentSociogram, errorCurrentSociogram } = useGetCurrentSociogram()

  if (isLoadingCurrentSociogram) return <BupSpinner size='medium' />

  if (errorCurrentSociogram) {
    return (
      <AlertInstrumentCard
        srcImage={SociogramImage}
        title={i18n.t('pages.data.instruments.teacher.sociogram.title')}
        errorMessage={i18n.t('pages.data.instruments.sociogramError')}
      />
    )
  }

  if (!dataCurrentSociogram) {
    return (
      <AlertInstrumentCard
        srcImage={SociogramImage}
        title={i18n.t('pages.data.instruments.teacher.sociogram.title')}
        errorMessage={i18n.t('pages.data.instruments.sociogramError')}
      />
    )
  }

  const { currentSociogram } = dataCurrentSociogram

  if (currentSociogram) {
    return (
      <LinkInstrumentCard
        srcImage={SociogramImage}
        title={i18n.t('pages.data.instruments.teacher.sociogram.title')}
        description={i18n.t('pages.data.instruments.teacher.sociogram.description')}
        onClick={() => navigate('/sociogram')}
      />
    )
  }

  return (
    <InfoInstrumentCard
      srcImage={SociogramImage}
      title={i18n.t('pages.data.instruments.teacher.sociogram.title')}
      description={i18n.t('pages.data.instruments.teacher.sociogram.description')}
    />
  )
}

export default SociogramCardContent
